import { FileUp, Keyboard, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

interface Props {
  onUpload: () => void;
  onManual: () => void;
}

export function ChoiceScreen({ onUpload, onManual }: Props) {
  return (
    <motion.div
      className="relative"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      {/* Title */}
      <div className="flex items-center gap-2 mb-1">
        <h1 className="text-2xl font-extrabold text-white">Register a Discovery meeting</h1>
        <Sparkles className="text-[#7573F7]" size={20} />
      </div>
      <p className="text-white/40 mb-6 text-sm">
        Choose how you'd like to submit. Uploading your lead handoff PDF is the fastest option — we'll extract the fields for you to review.
      </p>

      <div className="grid gap-4 md:grid-cols-2">
        {/* Upload PDF card */}
        <motion.button
          onClick={onUpload}
          className="relative backdrop-blur-2xl bg-white/[0.02] rounded-2xl border border-white/[0.08] p-6 text-left hover:bg-white/[0.05] hover:border-white/[0.12] transition-all group overflow-hidden"
          whileHover={{ scale: 1.01, y: -2 }}
          whileTap={{ scale: 0.99 }}
        >
          {/* Top gradient accent */}
          <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#05FAFC] to-[#7573F7]" />
          <FileUp className="text-[#7573F7] mb-3 group-hover:scale-110 transition-transform" size={28} />
          <div className="font-extrabold text-white mb-1">Upload PDF handoff</div>
          <div className="text-sm text-white/40 mb-3">Fastest. We parse + you confirm.</div>
          <span className="inline-block text-[10px] font-bold uppercase tracking-[0.15em] px-2.5 py-1 rounded-md bg-gradient-to-r from-[#05FAFC] to-[#7573F7] text-white">
            Recommended
          </span>
        </motion.button>

        {/* Manual entry card */}
        <motion.button
          onClick={onManual}
          className="relative backdrop-blur-2xl bg-white/[0.02] rounded-2xl border border-white/[0.06] p-6 text-left hover:bg-white/[0.05] hover:border-white/[0.10] transition-all group"
          whileHover={{ scale: 1.01, y: -2 }}
          whileTap={{ scale: 0.99 }}
        >
          <Keyboard className="text-white/40 mb-3 group-hover:scale-110 group-hover:text-white/60 transition-all" size={28} />
          <div className="font-extrabold text-white mb-1">Enter manually</div>
          <div className="text-sm text-white/40 mb-3">Type the fields yourself.</div>
        </motion.button>
      </div>
    </motion.div>
  );
}
